// Main JavaScript entry point
// Import all JavaScript files here

// Import mobile menu functionality - side effect import to ensure it's included
import './mobile-menu.js';

// Import share box functionality
import './share-box.js';

// Import search modal functionality
import './search-modal.js';

// Import sub-menu toggle functionality
import './sub-menu.js';

// Add more imports as you create new files:
// import './slider.js';
// import './forms.js';
// import './animations.js';
